<script>
  import { onMount, onDestroy } from 'svelte';
  import { sessionStore } from '../stores';
  import { orderedStyles } from '../utils/styleCatalog';
  import { launchStyle } from '../utils/editorLaunch';
  import { getFeed, feedImageUrl } from '../utils/communityApi';
  import { request } from '../utils/request';
  import { t, locale } from '../i18n';
  import { styleName } from '../content/publicSite.js';
  export let navigateTo;
  let examples = [], feedError = '', challenge = null, lastUser = null, mounted = false;
  let version = 0;
  $: if (mounted && lastUser !== $sessionStore.userId) { lastUser = $sessionStore.userId; loadChallenge(); }
  async function loadChallenge() {
    const current = ++version;
    challenge = null;
    if (!$sessionStore.loggedIn) return;
    try { const result = await request('/api/daily_style_challenge'); if (version === current) challenge = result; } catch {}
  }
  async function loadFeed() {
    feedError = '';
    try { examples = (await getFeed({ sort: 'random', scope: 'user_posts', limit: 12 })).slice(0, 6); }
    catch { feedError = 'feedError'; }
  }
  onMount(() => { mounted = true; loadFeed(); const recover = () => { loadFeed(); loadChallenge(); };
    document.addEventListener('serviceRecovered', recover); return () => document.removeEventListener('serviceRecovered', recover); });
  onDestroy(() => { version++; });
</script>
<section class="discovery">
  {#if challenge}
    <div class="challenge"><div><strong>{$t('dailyChallenge')}</strong><h2>{styleName($locale, challenge.style)}</h2></div>
      <button on:click={() => launchStyle(challenge)}>{$t(challenge.claimed_today ? 'againChallenge' : 'startChallenge')}</button>
    </div>
  {/if}
  <h2>{$t('newStyles')}</h2>
  <div class="styles">
    {#each orderedStyles().slice(0, 8) as style}
      <button class="style" on:click={() => launchStyle({ style: style.name })}><img src={style.image} alt={styleName($locale, style.name)} loading="lazy" /><span>{styleName($locale, style.name)}{#if style.isNew}<small>NEW</small>{/if}</span></button>
    {/each}
  </div>
  <div class="section-title"><h2>{$t('communityWorks')}</h2><button on:click={() => navigateTo('community')}>{$t('browseCommunity')}</button></div>
  {#if feedError}<p>{$t(feedError)} <button on:click={loadFeed}>{$t('retry')}</button></p>{/if}
  <div class="examples">{#each examples as item}<button class="example" on:click={() => navigateTo('community')}><img src={feedImageUrl(item)} alt={`${item.style} · ${item.author_name || '커뮤니티'} 작품`} loading="lazy" /><span>{item.style}</span></button>{/each}</div>
  {#if !examples.length && !feedError}<p>{$t('firstWork')}</p>{/if}
</section>
<style>
  .discovery { margin: 40px 0 64px; } .challenge { background: #fe6a3710; padding: 24px; border: 1px solid #fe6a3755; border-radius: 20px; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap; }
  h2 { margin: 20px 0; } p { line-height: 1.7; } button { font: inherit; color: inherit; background: transparent; border: 1px solid #8884; border-radius: 12px; padding: 10px 16px; cursor: pointer; }
  .styles, .examples { display: grid; gap: 16px; grid-template-columns: repeat(4, minmax(0, 1fr)); } .examples { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .style, .example { display: grid; padding: 0; overflow: hidden; text-align: left; border-radius: 16px; } img { width: 100%; aspect-ratio: 4 / 5; object-fit: cover; } span { padding: 12px; } small { float: right; color: #e65b23; font-weight: bold; }
  .section-title { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 24px; }
  @media (max-width: 800px) { .examples { grid-template-columns: repeat(3, minmax(0, 1fr)); } } @media (max-width: 520px) { .styles { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>
